import { render, staticRenderFns } from "./AppContextMenu.vue?vue&type=template&id=58466476&scoped=true&"
import script from "./AppContextMenu.vue?vue&type=script&lang=ts&"
export * from "./AppContextMenu.vue?vue&type=script&lang=ts&"
import style0 from "./AppContextMenu.vue?vue&type=style&index=0&id=58466476&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58466476",
  null
  
)

export default component.exports